import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'randomNumber',
  standalone: true
})
export class RandomNumberPipe implements PipeTransform {

  transform(max: number): number {
      return Math.floor(Math.random() * max);
  }
}
